import { render, staticRenderFns } from "./WealthPortfolioV2.vue?vue&type=template&id=6ab01ad8&scoped=true&"
import script from "./WealthPortfolioV2.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WealthPortfolioV2.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WealthPortfolioV2.vue?vue&type=style&index=0&id=6ab01ad8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab01ad8",
  null
  
)

export default component.exports